import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CheckoutType } from 'src/app/enums/assessment.enum';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from 'src/app/config/app.config';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  SERVER_URL = environment.SERVER_URL;
  private cartSubject = new BehaviorSubject<number>(this.getCartLengthFromLocalStorage());

  constructor(private http: HttpClient) {}

  // Expose the cart count as an observable
  addToCartSubject = this.cartSubject.asObservable();

  // Get cart items from localStorage
  private getCartLengthFromLocalStorage():number {
    let cartDetails = this.getCartDetailsFromLocalStorage();
    cartDetails = cartDetails.filter((item:any) => item.checkoutType === CheckoutType.STUDENT_ASSESSMENT);
    return cartDetails?.length;
  }

  // Update count
  updateCartCount(count: number) {
    this.cartSubject.next(count);
  }

  // Increment count
  incrementCart(count: number = 1) {
    const newCount = this.cartSubject.getValue() + count;
    this.updateCartCount(newCount);
  }

  // Decrement count
  decrementCart(count: number = 1) {
    let newCount = this.cartSubject.getValue() - count;
    if (newCount < 0) newCount = 0; // Prevent negative values
    this.updateCartCount(newCount);
  }

  // Refresh count from localStorage
  refreshCartCount() {
    const count = this.getCartLengthFromLocalStorage()
    this.updateCartCount(count);
  }

  // Retrieves cart details from localStorage 
  getCartDetailsFromLocalStorage(): any[] {
    const cart_details = JSON.parse(localStorage.getItem('cart_details') || "[]");
    return cart_details;
  }

  addToCart(assessment: any) {
    const assessmentDocId = assessment.assessment.assessmentDocId;

    let cart = this.getCartDetailsFromLocalStorage();
    const assessmentExists = cart.find( item => assessmentDocId == item.assessment.assessmentDocId);
    if(assessmentExists == undefined) {
      cart.push(assessment);
    }

    localStorage.setItem('cart_details', JSON.stringify(cart));
    this.refreshCartCount();
  }

  setCartDetailsInLocalStorage(cartDetails: any[]) {
    localStorage.setItem('cart_details', JSON.stringify(cartDetails));
  }

  removeCartItemsFormLocalStorage(assessmentIds:string[]){
    let cartDetails:any[] = this.getCartDetailsFromLocalStorage();
    cartDetails = cartDetails.filter(item => !assessmentIds.includes(item?.assessment?.assessmentDocId));
    localStorage.setItem('cart_details', JSON.stringify(cartDetails));
    this.refreshCartCount();
  }

  removeOlympiadsFromLocalStorage(){
    let cartDetails:any[] = this.getCartDetailsFromLocalStorage();
    cartDetails = cartDetails.filter(item => item?.assessment?.store !== AppConfig.stores.store2.slug);
    localStorage.setItem('cart_details', JSON.stringify(cartDetails));
    this.refreshCartCount();
  }
  
  applyCoupon(couponCode: string, subTotal: number, checkoutType: string, storeSlug:string): Observable<any> {
    const API_URL = `${this.SERVER_URL}coupons/applyCoupon`;
    return this.http.post(API_URL, {couponCode, subTotal, checkoutType, storeSlug}).pipe(
      map((res) => res)
    );
  }

}
